const FALL_COLLECTION_DATA = {
  "gid://shopify/Product/7374582513856": {
    type: "apparel",
    title: "Rockstar Crop Top",
    img: ["crop-top__black"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
    sizeGuide: {
      horizontal: [
        { name: "Body Length", imperial: [19.5, 20, 22, 24, 26] },
        { name: "Body Width", imperial: [16.25, 17.75, 19.5, 21.5, 23.5] },
      ],
      vertical: ["S", "M", "L", "XL", "2XL"],
    },
    hidden: true,
  },
  "gid://shopify/Product/7374596407488": {
    type: "apparel",
    title: "Stop Drop and Betty Rock Crop Top",
    img: ["crop-sdbr__teal"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
    sizeGuide: {
      horizontal: [
        { name: "Body Length", imperial: [19.5, 20, 22, 24, 26] },
        { name: "Body Width", imperial: [16.25, 17.75, 19.5, 21.5, 23.5] },
      ],
      vertical: ["S", "M", "L", "XL", "2XL"],
    },
    hidden: true,
  },
  "gid://shopify/Product/7374599618752": {
    type: "apparel",
    title: "Rock Your Life Crop Top",
    img: ["crop-ryl__teal"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
    sizeGuide: {
      horizontal: [
        { name: "Body Length", imperial: [19.5, 20, 22, 24, 26] },
        { name: "Body Width", imperial: [16.25, 17.75, 19.5, 21.5, 23.5] },
      ],
      vertical: ["S", "M", "L", "XL", "2XL"],
    },
    hidden: true,
  },
  "gid://shopify/Product/7374601781440": {
    type: "apparel",
    title: "All or Something Crop Top",
    img: ["crop-aos__heather-grey"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
    sizeGuide: {
      horizontal: [
        { name: "Body Length", imperial: [19.5, 20, 22, 24, 26] },
        { name: "Body Width", imperial: [16.25, 17.75, 19.5, 21.5, 23.5] },
      ],
      vertical: ["S", "M", "L", "XL", "2XL"],
    },
    hidden: true,
  },
  "gid://shopify/Product/7374611513536": {
    type: "apparel",
    title: "Fleece-lined Hoodie",
    img: ["hoodie-rockstar__black"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold with like colors, normal cycle only. Do not bleach. Tumble dry low. Do not iron design.",
    sizeGuide: {
      horizontal: [
        { name: "Body Length", imperial: [26, 27, 28, 29, 30, 31] },
        { name: "Chest Width (Laid Flat)", imperial: [19, 20, 21, 22, 23, 24] },
        {
          name: "Sleeve Length (From Center Back)",
          imperial: [31.25, 32.25, 33.25, 34.25, 35.25, 36.25],
        },
      ],
      vertical: ["XS", "S", "M", "L", "XL", "2XL"],
    },
  },
  "gid://shopify/Product/7374612725952": {
    type: "apparel",
    title: "All or Something Racerback Tank",
    img: ["tank-aos__vintage-black", "tank-aos__purple-rush"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
    sizeGuide: {
      horizontal: [
        {
          name: "Body Length",
          imperial: [25.875, 26.5, 27.125, 27.75, 28.375, 29],
        },
        {
          name: "Chest Width (Laid Flat)",
          imperial: [15, 16, 17, 18, 19.5, 21],
        },
      ],
      vertical: ["XS", "S", "M", "L", "XL", "2XL"],
    },
  },
  "gid://shopify/Product/7374616101056": {
    type: "apparel",
    title: "Rock Your Life Racerback Tank",
    img: ["tank-ryl__vintage-hot-pink"],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
    sizeGuide: {
      horizontal: [
        {
          name: "Body Length",
          imperial: [25.875, 26.5, 27.125, 27.75, 28.375, 29],
        },
        {
          name: "Chest Width (Laid Flat)",
          imperial: [15, 16, 17, 18, 19.5, 21],
        },
      ],
      vertical: ["XS", "S", "M", "L", "XL", "2XL"],
    },
  },
  // "gid://shopify/Product/7374623080640": {
  //   type: "apparel",
  //   title: "Rock Your Life Muscle Tank",
  //   img: ["muscle-tank-ryl__antique-denim_grey"],
  //   collection: "apparel",
  //   collectionInfo: "apparel-shirt",
  //   care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
  //   sizeGuide: {
  //     horizontal: [
  //       {
  //         name: "Body Length",
  //         imperial: [24.25, 24.875, 25.5, 26.125, 26.75, 27.375],
  //       },
  //       {
  //         name: "Chest Width (Laid Flat)",
  //         imperial: [15.125, 16.125, 17.125, 18.125, 19.625, 21.125],
  //       },
  //     ],
  //     vertical: ["XS", "S", "M", "L", "XL", "2XL"],
  //   },
  //
  // },
  // "gid://shopify/Product/7374635368640": {
  //   type: "apparel",
  //   title: "Stop, Drop and Betty Rock Muscle Tank",
  //   img: [`muscle-tank-sdbr__antique-denim_grey`],
  //   collection: "apparel",
  //   collectionInfo: "apparel-shirt",
  //   care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
  //   sizeGuide: {
  //     horizontal: [
  //       {
  //         name: "Body Length",
  //         imperial: [24.25, 24.875, 25.5, 26.125, 26.75, 27.375],
  //       },
  //       {
  //         name: "Chest Width (Laid Flat)",
  //         imperial: [15.125, 16.125, 17.125, 18.125, 19.625, 21.125],
  //       },
  //     ],
  //     vertical: ["XS", "S", "M", "L", "XL", "2XL"],
  //   },
  // },
  // "gid://shopify/Product/7375209332928": {
  //   type: "apparel",
  //   title: "All or Something Muscle Tank",
  //   img: [`muscle-tank-aos__stonewash-denim`],
  //   collection: "apparel",
  //   collectionInfo: "apparel-shirt",
  //   care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low. Do not iron over decoration.",
  //   sizeGuide: {
  //     horizontal: [
  //       {
  //         name: "Body Length",
  //         imperial: [24.25, 24.875, 25.5, 26.125, 26.75, 27.375],
  //       },
  //       {
  //         name: "Chest Width (Laid Flat)",
  //         imperial: [15.125, 16.125, 17.125, 18.125, 19.625, 21.125],
  //       },
  //     ],
  //     vertical: ["XS", "S", "M", "L", "XL", "2XL"],
  //   },
  // },
  // "gid://shopify/Product/7375221915840": {
  //   type: "apparel",
  //   title: "Rock Your Life Slouchy T",
  //   img: [`slouchy-t-ryl__black`],
  //   collection: "apparel",
  //   collectionInfo: "apparel-shirt",
  //   care: "Machine wash cold. Only non-chlorine bleach when needed. Tumble dry low or hang to dry. Do not iron over decoration.",
  //   sizeGuide: {
  //     horizontal: [
  //       {
  //         name: "Body Length",
  //         imperial: [25.25, 25.75, 26.375, 27, 27.625],
  //       },
  //       {
  //         name: "Chest Width (Laid Flat)",
  //         imperial: [20, 21.5, 23.5, 25.5, 27.5],
  //       },
  //     ],
  //     vertical: ["S", "M", "L", "XL", "2XL"],
  //   },
  // },
  "gid://shopify/Product/7375232696512": {
    type: "apparel",
    title: "All or Something T (unisex)",
    img: [`aos-unisex-t__storm-grey`],
    collection: "apparel",
    collectionInfo: "apparel-shirt",
    care: "Machine wash warm, inside out,  with like colors. Only non-cholorine bleach. Tumble dry low. Medium  iron. Do not iron decoration. Do not dry clean.",
    sizeGuide: {
      horizontal: [
        {
          name: "Body Length at Back",
          imperial: [27, 28, 29, 30, 31, 32],
        },
        {
          name: "Chest Width",
          imperial: [16.5, 18, 20, 22, 24, 26],
        },
      ],
      vertical: ["XS", "S", "M", "L", "XL", "2XL"],
      notes: [
        {
          title: "Body Length at Back",
          content: "Measured from high point shoulder to finished hem at back.",
        },
        {
          title: "Chest Width",
          content: "Measured across the chest one inch below armhole when laid flat.",
        },
      ],
    },
  },
}
export default FALL_COLLECTION_DATA
